<template>
  <div class="personal-center">
    <div class="center-bg"></div>
      <div class="avatar_box">
        <div class="avatar">
            <div class="avatar-background">
              <van-image round width="70px" height="70px" alt="头像" src="/static/user_avatar.jpg" />
            </div>
            <div class="name_text">{{name}}</div>
        </div>
        <div class="identity_text">公益专员</div>
      </div>
      <van-cell-group class="user_info">
        <van-field v-model="name" label="姓名" readonly/>
        <van-field v-model="mobile" label="手机号" readonly/>
        <van-field v-model="role" label="角色" readonly/>
        <van-field v-model="region" label="服务区域" readonly autosize type="textarea"/>
      </van-cell-group>
      <div class="btn">
        <van-button color="#0AA8AF" round block @click="logOut()">退出登录</van-button>
      </div>
  </div>
</template>

<script>
import {Toast} from 'vant'
import { mapState } from 'vuex';
import { Logout } from '@/api/publicWelfareStaff';
Logout
export default {
    components:{
      Toast
    },
    data(){
        return {
            // user_name:"张三",
            name: "张三",
            mobile: "18099990000",
            role: "公益专员",
            region: "上海",
        }
    },
    computed: {
      ...mapState(['publicWelfareStaff'])
    },
    created(){
        if(this.publicWelfareStaff.volunteer_info){
                const {
                    city,
                    messageCount,
                    statusing_list,
                    volunteer
                }=this.publicWelfareStaff.volunteer_info
                if(volunteer) {
                  this.name=volunteer.name
                  this.role=volunteer.role
                  this.mobile=volunteer.mobile.substring(0,4)+'****'+volunteer.mobile.substring(8,12)
                }
                if(city) {
                    let str=''
                    city.forEach(ele=>{ str=str+'、'+ele})
                    this.region=str.slice(1)
                }
            }
    },
    methods:{
        logOut() {
          Logout().then(res=>{ 
            if(res){
              Toast.success('退出成功');
              this.$store.commit("clearPublicWelfareStaff")
              this.$router.replace({name:'staffCheckin'})
            }
          })
          // 退出登录
        }
    }
}
</script>

<style lang="less" scoped>
.personal-center{
  min-height:100vh;
  background-color: #F9F9F9 ;
  .btn{
    padding: 0 30px;
  }
  .center-bg{
    height: 20vh;
    background:#0AA8AF;
  }
  .avatar_box{
    background:#fff;
    margin: -8vh 15px 0;
    border-radius: 10px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);
    display: flex;
    justify-content: space-between;
    align-items: center;
    .identity_text{
      font-size: 15px;
      color: #0AA8AF;
      margin-right: 25px;
    }
    .avatar{
      display: flex;
      align-items: center;
      padding: 15px 0px 15px 20px;
      .avatar-background{
        box-shadow: 0px 1px 6px 3px rgba(204, 204, 204, 0.3);
        border-radius: 50%;
        display: flex;
      }
      .name_text{
        font-size: 16px;
        color: #0A0A0A;
        margin-left: 16px;
        font-family: PingFangSC-Regular;
      }
    }
    
  }
  .user_info{
    margin: 25px 15px 30px;
    border-radius: 5px;
    box-shadow: 0px 2px 8px 0px rgba(0, 0, 0, 0.1);

  }
}

</style>